import { useQuery } from '@tanstack/react-query';
import { adminApi, Tenant } from '../api/client';
import { useImpersonationStore } from '../store/impersonationStore';

/**
 * Dropdown for staff users to select which tenant to view client pages as.
 * Only shown in the client Layout (not admin).
 */
export function TenantSelector() {
  const { selectedTenantId, setTenant, clear } = useImpersonationStore();

  const { data: tenants, isLoading } = useQuery({
    queryKey: ['admin', 'tenants'],
    queryFn: () => adminApi.getTenants(),
  });

  const activeTenants = (tenants || []).filter((t: Tenant) => t.status === 'active');

  return (
    <div className="flex items-center space-x-2">
      <label htmlFor="tenant-select" className="text-xs text-gray-500 whitespace-nowrap">
        View as:
      </label>
      <select
        id="tenant-select"
        value={selectedTenantId || ''}
        onChange={(e) => {
          const id = e.target.value;
          if (!id) {
            clear();
          } else {
            const tenant = activeTenants.find((t: Tenant) => t.tenantId === id);
            setTenant(id, tenant?.name || id);
          }
        }}
        className="text-xs border border-gray-300 rounded px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-primary-500 max-w-[200px]"
        disabled={isLoading}
      >
        <option value="">
          {isLoading ? 'Loading...' : '-- Select Tenant --'}
        </option>
        {activeTenants.map((t: Tenant) => (
          <option key={t.tenantId} value={t.tenantId}>
            {t.name}
          </option>
        ))}
      </select>
      {selectedTenantId && (
        <span className="px-1.5 py-0.5 text-xs font-medium bg-blue-100 text-blue-800 rounded">
          Impersonating
        </span>
      )}
    </div>
  );
}
